



































import { Component, Vue } from 'vue-property-decorator';
import SectionHeader from '../shared/SectionHeader.vue';
import FullWidthTitle from '../shared/FullWidthTitle.vue';
import Spacer from '../shared/Spacer.vue';

@Component({
  components: { SectionHeader, FullWidthTitle, Spacer },
})
export default class Preselections extends Vue {
}
